import { debounce } from "lodash";
import { useEffect, useMemo, useState } from "react";
import { useDispatch } from "react-redux";
import { calculQueryEnv } from "../../components/environnement/utilsEnv";
import {
  MultiSelectEnv,
} from "../../components/environnement/MultiSelectEnv";
import { FieldElementSearch } from "../../components/list/FieldElementSearch";
import { useAppSelector } from "../../hooks/hooks";
import { setParamTopologyPagination } from "./TreatmentSlice";

const HandleTreatment = () => {
  const dispatch = useDispatch();

  const [envsSelected, setSelectedEnvs] =
    useState<{ name: string; code: string }[]>([]);

  const queryEnv = useMemo(() => {
    return calculQueryEnv(envsSelected);
  }, [envsSelected]);

  const paramPagination = useAppSelector(
    (state) => state.treatment.paramTopologiesPagination
  );


  useEffect(() => {
    dispatch(
      setParamTopologyPagination({
        ...paramPagination,
        env: queryEnv,
      })
    );
  }, [queryEnv]);

  return (
    <>
      <div className="mb-4 grid">
        <div className="col-4">
          {/* custom input for search element (in this case search of topologies) */}

          <FieldElementSearch
            value={paramPagination.search}
            changeValue={(filerValueChange: string) => {
              dispatch(
                setParamTopologyPagination({
                  ...paramPagination,
                  search: filerValueChange,
                  page: 0,
                })
              );
            }}
            placeholder="Rechercher"
          />
        </div>
        <div className="col-2">
          <MultiSelectEnv
            envsSelected={envsSelected}
            setSelectedEnvs={(envs) => {
              setSelectedEnvs(envs);
            }}
          />
        </div>
      </div>
    </>
  );
};

export default HandleTreatment;
